import axios from 'axios';
import { logAxiosError } from 'Utils';
const ACTIVATION_API_URL = process.env.REACT_APP_ACTIVATION_API_URL;

const submitCredentialsForActivationCode = async (uim, code) => {
  try {
    // Get user's info and activate it
    const {
      access_token,
      id_token,
      refresh_token,
      uid,
    } = await uim.getUimClientInfo();
    await axios.post(`${ACTIVATION_API_URL}/activate/${code}`, {
      access_token,
      id_token,
      refresh_token,
      uid,
    });
  } catch (err) {
    logAxiosError(err);
    throw new Error(err);
  }
};

export default submitCredentialsForActivationCode;
